module.exports = __webpack_public_path__ + "static/playgroup@large-de02735e38333fae4d438dbeae5abd14.jpg";